/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-wrap-multilines */
import Text from '@deprecated-ui/common/Text';
import Tooltip from '@deprecated-ui/common/Tooltip';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';

const URL_VERIFICATION_ARTICLE = 'https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/';

function LabelVerified() {
  return (
    <Tooltip
      placement="rightTop"
      autoAdjustOverflow
      overlayInnerStyle={{
        background: 'rgba(64, 64, 64, 0.85)',
      }}
      title={
        <p style={{ marginBottom: 0 }}>
          <Text
            family="bold"
            color={color.light}
            size="12px"
            style={{ lineHeight: '1.5' }}
          >
            Verified Account
          </Text>
          <Text color={color.light} size="12px" height="1.5">
            Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.{' '}
            <span
              style={{ color: color.primary, cursor: 'pointer' }}
              onClick={() => window.open(URL_VERIFICATION_ARTICLE)}
            >
              Pelajari Lebih Lanjut
            </span>
          </Text>
        </p>
      }
    >
      <IconWrapper padding="0 4px">
        <Iconmoon
          className="icon-custom_verified-circle"
          size="12px"
          color={color.primary}
        />
      </IconWrapper>
    </Tooltip>
  );
}

export default LabelVerified;
